import * as _ from 'lodash';

export function localeToCulture(locale: string): string {
  const localeToCultureMap = { en: 'en-GB', fr: 'fr-FR', nl: 'nl-NL' };

  const culture = _.get(localeToCultureMap, locale, locale);
  return culture;
}
